import { z } from 'zod';
// Slice 9 — Hardening: ErrorLog + ConfiguracionSistema (admin-only).
export const NIVELES_ERROR = ['WARN', 'ERROR', 'FATAL'];
// ============================================================================
// ErrorLog
// ============================================================================
export const errorLogPublicSchema = z.object({
    id: z.string(),
    creadoEn: z.string(),
    correlationId: z.string(),
    nivel: z.enum(NIVELES_ERROR),
    mensaje: z.string(),
    stack: z.string().nullable(),
    requestPath: z.string().nullable(),
    requestMethod: z.string().nullable(),
    requestBody: z.unknown().nullable(),
    contexto: z.unknown().nullable(),
    usuarioId: z.string().nullable(),
    resuelto: z.boolean(),
    resueltoPor: z.object({ id: z.string(), nombre: z.string(), email: z.string() }).nullable(),
    resueltoEn: z.string().nullable(),
    notas: z.string().nullable(),
});
export const errorLogListarQuerySchema = z.object({
    resuelto: z
        .union([z.literal('true'), z.literal('false'), z.boolean()])
        .transform((v) => v === true || v === 'true')
        .optional(),
    nivel: z.enum(NIVELES_ERROR).optional(),
    q: z.string().max(200).optional(), // búsqueda en mensaje
    desde: z.coerce.date().optional(),
    hasta: z.coerce.date().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const errorLogResolverSchema = z.object({
    resuelto: z.boolean(),
    notas: z.preprocess((v) => (v === '' || v == null ? undefined : v), z.string().max(5000).optional()),
});
// ============================================================================
// ConfiguracionSistema
// ============================================================================
export const configuracionItemSchema = z.object({
    clave: z.string(),
    valor: z.unknown(),
    descripcion: z.string().nullable(),
    actualizadoEn: z.string(),
});
export const configuracionActualizarSchema = z.object({
    valor: z.unknown(),
});
//# sourceMappingURL=hardening.js.map